import { useStore, useConfirm, useToast } from '@balm-ui';
import { useDialog } from '@balm-ui-pro';
import { isDev } from '@yiban-shared/config';

const $confirm = useConfirm();
const $toast = useToast();
const $dialog = useDialog();

export default ({ getFormDataWithDefaultParams, customTopActionHandler }) =>
  async function topActionHandler(action, listViewData) {
    const $store = useStore();

    // 列表页顶部按钮通用动作
    const actionType = action.type;
    const { model, searchForm, listData, refreshData, resetSelectedRows } =
      listViewData;

    // 1. 批量操作 type 必须以 `multi-` 开头
    if (/^multi-/.test(actionType)) {
      const { selectedRows } = listData;
      const actionText = action.text || '批量操作';

      if (selectedRows.length) {
        let formData = {
          [action.keyField || 'ids']: selectedRows
        };
        if (action.requiredParams) {
          formData = { ...formData, ...action.requiredParams };
        }
        formData = getFormDataWithDefaultParams
          ? await getFormDataWithDefaultParams('top-action', formData, {
              actionType,
              action,
              data: searchForm.data,
              ...listViewData
            })
          : formData;

        isDev && console.info('handleTopAction', model, formData);

        if (await $confirm(`确定要${actionText}所有选中的数据吗？`)) {
          const apiAction = actionType.replace('multi-', '');
          const customApiAction = action.apiAction;

          /^del/.test(apiAction)
            ? await $store.$deleteModel(model, formData, {
                apiAction:
                  customApiAction || (apiAction === 'delete' ? '' : apiAction)
              })
            : await $store.$updateModel(model, formData, {
                apiAction:
                  customApiAction || (apiAction === 'update' ? '' : apiAction)
              });

          $toast(`已${actionText}`);
          refreshData();
          resetSelectedRows();
        }
      } else {
        $toast(`请选择要${actionText}的数据`);
      }
    } else {
      // 2. 弹窗操作
      if (actionType === 'dialog') {
        const { config } = action;

        $dialog({
          className: config.className || '',
          title: config.title || '',
          component: config.component,
          modelValueKeys: config.modelValueKeys || [],
          attrOrProp: Object.assign(
            {
              actionConfig: [
                {
                  type: 'close',
                  text: '关闭',
                  attrOrProp: {
                    outlined: true
                  }
                },
                {
                  type: 'submit',
                  text: '保存',
                  attrOrProp: {
                    raised: true
                  }
                }
              ]
            },
            config.attrOrProp || {}
          ),
          handler: config.handler || (() => {}),
          refreshOnSave: config.refreshOnSave === false ? false : true,
          refresh: refreshData
        });
      } else {
        // 3. 自定义操作
        customTopActionHandler(action, listViewData);
      }
    }
  };
